import { Grid, Paper, Typography, Box, Container } from "@mui/material";

const Dashboard = ({ t }) => {
  return (
    <Box component="main">
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className="peperdashboard" sx={{ p: 1 }}>
              <Typography variant="h2" component="h2">{t('bienvenido')}</Typography>
              <Typography variant="h6" component="p">
                {t('mensaje_bienvenida')}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
export default Dashboard;
